import {Routes} from "@angular/router";
import {WorkflowChangeSlaComponent} from "./workflow-change-sla.component";

export const workflowChangeSlaRouting: Routes = [
    { path: 'change-sla/:aid', component: WorkflowChangeSlaComponent},
]
